export default __webpack_public_path__ + "static/media/MALLAPPA.2abf2117.JPG";